/** Variantes visuais — alinhadas à assinatura AI Greening / GREENING_BRAND. */
export type GreeningBrandTermVariant = 'oaas' | 'greenplat' | 'verde' | 'azul' | 'ctre';

export interface GreeningBrandTermDef {
  variant: GreeningBrandTermVariant;
  /** Padrão case-insensitive; ordem = prioridade (mais longo primeiro). */
  pattern: RegExp;
}

/** Termos de marca — match do mais específico ao mais curto. */
export const GREENING_BRAND_TERM_DEFS: readonly GreeningBrandTermDef[] = [
  {
    variant: 'oaas',
    pattern: /(?:\*\*)?OaaS\s+GreenPlat(?:\*\*)?/gi,
  },
  {
    variant: 'verde',
    pattern: /(?:\*\*)?Plataforma\s+Verde(?:\*\*)?/gi,
  },
  {
    variant: 'azul',
    pattern: /(?:\*\*)?Plataforma\s+Azul(?:\*\*)?/gi,
  },
  {
    variant: 'greenplat',
    pattern: /(?:\*\*)?GreenPlat(?:\*\*)?/gi,
  },
  {
    variant: 'ctre',
    pattern: /(?:\*\*)?\bCTRE\b(?:\*\*)?/gi,
  },
];

export function stripMarkdownBoldEdges(value: string): string {
  return value.replace(/^\*\*/, '').replace(/\*\*$/, '');
}
